import { Link } from "react-router-dom";
import MainNav from "../MainNav/MainNav";
import "./Header.css";
import csLogo from "../../img/CSHub-logo.png";
import toolLogo from "../../img/streamlined-tool-log.png"; // Adjust the path to your second logo

const Header = () => {
    return (
        <header className="header">
            <Link to="/">
                <img src={csLogo} alt="CSHub Logo" id="header__logo" />
            </Link>
            <Link to="/">
                <img src={toolLogo} alt="Second Logo" id="header__second-logo" />
            </Link>
            <div className="header__panel">
                <h1 className="header__title">MIT CSHub Streamlined Pavement Life Cycle Assessment and Life Cycle Cost Analysis Tool</h1>
                <MainNav isLoggedIn="true" />
            </div>
        </header>
    );
}

export default Header;
